// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout___hBmp","brandPattern":"page-header_brandPattern__6Tdka","content":"page-header_content__T9q6q"};